import { eventBus } from './eventBus';
import state from '../store/globalStore';
import { authComponentsUrl, importAuthUtils } from './auth';
import { importPSXFraudUtils } from './detectFraud';
import { ErrorType, noticeError } from './newRelic';
import { isWebExperience } from './nativeAppUtils';
import { jwtDecode } from 'jwt-decode';

export const consumerAuth = async (component: any) => {

  const handleCheckIfLoggedIn = async () => {
    let cognitoIdToken = '';
    let cognitoAccessToken = '';
    let isUserLoggedIn = false;

    try {
      if (!isWebExperience) {
        const mobileData = await globalThis.autotraderMobileApp?.auth.getTokens();
        if (mobileData?.tokens && mobileData?.tokens?.idToken && mobileData?.tokens?.accessToken) {
          cognitoIdToken = mobileData?.tokens?.idToken
          cognitoAccessToken = mobileData?.tokens?.accessToken
          isUserLoggedIn = true;
        }
      }
      else {
        cognitoIdToken = await globalThis.PSX_AUTH.getCognitoIdToken();
        cognitoAccessToken = await globalThis.PSX_AUTH.getCognitoAccessToken();
      }
    } catch (e) { /* empty */ }
    state.cognitoIdToken = cognitoIdToken;
    state.cognitoAccessToken = cognitoAccessToken;
    state.isUserLoggedIn = isWebExperience ? await globalThis.PSX_AUTH.isUserSignedIn() : isUserLoggedIn;
  };
  
  if (typeof globalThis.PSX_AUTH !== 'undefined') {
    await handleCheckIfLoggedIn();
    return globalThis.PSX_AUTH;
  }


  try {
    await importAuthUtils();

    // Inject auth component script into the component's shadow DOM
    const scriptElement = document.createElement('script');
    scriptElement.async = true;
    scriptElement.type = 'module';
    scriptElement.src = authComponentsUrl;
    component.shadowRoot.appendChild(scriptElement);

    // Listening to Sign In and Out events
    ['auth.signout', 'auth.signin'].forEach(eventName => {
      eventBus.on(eventName, async () => {
        await handleCheckIfLoggedIn();
        await importPSXFraudUtils(component);
      });
    });

    await handleCheckIfLoggedIn();
  } catch (error) {
    noticeError(error, ErrorType.UNKNOWN, {
      methodName: "consumerAuth",
    });
    console.error('Failed to load auth utility scripts:', error);
  }
  return globalThis.PSX_AUTH;
};

export const getAuthToken = async () => {
  let idToken = '';
  try {
    if (!isWebExperience) {
      const mobileAuth = await globalThis?.autotraderMobileApp?.auth?.getTokens();
      if (mobileAuth?.tokens?.idToken) {
        idToken = mobileAuth?.tokens?.idToken;
      }
    }
    else {
      idToken = await globalThis.PSX_AUTH.getCognitoIdToken();
    }
  }
  catch (error) { 
    console.error('Failed to to get cognitoIdToken:', error);
  }
  return `Bearer ${idToken}`;
}

export const getConsumerIdFromJwt = (authToken: string) => {
  try {
    const cognitoUserData: any = authToken && jwtDecode(authToken);
    return cognitoUserData['custom:consumer_id'];
  } catch (error) {
    return null;
  }
};
